import { PERMISSION } from '@/constants/permission.constant';

// Helper function to create route meta
const createMeta = (permissions, title, options = {}) => ({
  requiresAuth: true,
  permissions: Array.isArray(permissions) ? permissions : [permissions],
  title,
  ...options,
});

const inventoriesChildrenRoute = [
  {
    path: 'category',
    name: 'inventory-catory',
    component: () => import('@/views/Inventories/category/index.vue'),
    meta: createMeta(PERMISSION.CATEGORY_READ, 'Category List'),
    
  },
  {
    path: 'category/new',
    name: 'inventory-catory-new',
    component: () => import('@/views/Inventories/category/CreateCategory.vue'),
    meta: createMeta(PERMISSION.CATEGORY_CREATE, 'Create Category'),
  },
  {
    path: 'category/edit/:id',
    name: 'inventory-catory-edit',
    component: () => import('@/views/Inventories/category/EditCategory.vue'),
    meta: createMeta(PERMISSION.CATEGORY_UPDATE, 'Edit Category'),
  },
  {
    path: 'storage/new',
    name: 'inventory-storage-new',
    component: () => import('@/views/Inventories/storage/CreateStorage.vue'),
    meta: createMeta(PERMISSION.STORAGE_CREATE, 'Create Storage'),
  },
  {
    path: 'storage',
    name: 'inventory-storage',
    component: () => import('@/views/Inventories/storage/index.vue'),
    meta: createMeta(PERMISSION.STORAGE_READ, 'Storage List'),
  },
  {
    path: 'storage/edit/:id',
    name: 'inventory-storage-edit',
    component: () => import('@/views/Inventories/storage/EditStorage.vue'),
    meta: createMeta(PERMISSION.STORAGE_UPDATE, 'Edit Storage'),
  },
  {
    path: 'parts',
    name: 'inventory-parts-tab',
    component: () => import('@/views/Inventories/parts/index.vue'),
    meta: createMeta([PERMISSION.PART_ITEMS_READ, PERMISSION.PART_ISSUE_READ, PERMISSION.PART_RETURN_READ], 'Parts'),
    children: [
      {
        path: 'part',
        name: 'inventory-parts',
        component: () => import('@/views/Inventories/parts/part/index.vue'),
        meta: createMeta(PERMISSION.PART_ITEMS_READ, 'Parts List'),
      },
      {
        path: 'part-new',
        name: 'inventory-parts-new',
        component: () => import('@/views/Inventories/parts/part/CreatePart.vue'),
        meta: createMeta(PERMISSION.PART_ITEMS_CREATE, 'Create Part'),
      },
      {
        path: 'part-edit/:id',
        name: 'inventory-parts-edit',
        component: () => import('@/views/Inventories/parts/part/EditPart.vue'),
        meta: createMeta(PERMISSION.PART_ITEMS_UPDATE, 'Edit Part'),
      },
      {
        path: 'part-issue',
        name: 'inventory-issue',
        component: () => import('@/views/Inventories/parts/parts-issue/index.vue'),
        meta: createMeta(PERMISSION.PART_ISSUE_READ, 'Part Issue'),
      },
      {
        path: 'part-issue-new',
        name: 'inventory-issue-new',
        component: () => import('@/views/Inventories/parts/parts-issue/CreatePartIssue.vue'),
        meta: createMeta(PERMISSION.PART_ISSUE_CREATE, 'Create Part Issue'),
      },
      {
        path: 'part-issue/:id',
        name: 'inventory-issue-edit',
        component: () => import('@/views/Inventories/parts/parts-issue/index.vue'),
        meta: createMeta(PERMISSION.PART_ISSUE_READ, 'Part Issue Detail'),
      },
      {
        path: 'part-return',
        name: 'inventory-return',
        component: () => import('@/views/Inventories/parts/parts-return/index.vue'),
        meta: createMeta(PERMISSION.PART_RETURN_READ, 'Part Return'),
      },
      {
        path: 'part-return/:id',
        name: 'inventory-return-detail',
        component: () => import('@/views/Inventories/parts/parts-return/index.vue'),
        meta: createMeta(PERMISSION.PART_RETURN_READ, 'Part Return Detail'),
      },
      {
        path: 'part-return-edit/:id',
        name: 'inventory-return-edit',
        component: () => import('@/views/Inventories/parts/parts-return/EditPartReturn.vue'),
        meta: createMeta(PERMISSION.PART_RETURN_UPDATE, 'Edit Part Return'),
      },
      {
        path: 'part-return-new',
        name: 'inventory-return-new',
        component: () => import('@/views/Inventories/parts/parts-return/CreatePartReturn.vue'),
        meta: createMeta(PERMISSION.PART_RETURN_CREATE, 'Create Part Return'),
      },
    ],
  },
  {
    path: 'supplier',
    name: 'inventory-supplier-list',
    component: () => import('@/views/Inventories/supplier/index.vue'),
    meta: createMeta(PERMISSION.SUPPLIER_READ, 'Supplier List'),
  },
  {
    path: 'supplier/new',
    name: 'inventory-supplier-create',
    component: () => import('@/views/Inventories/supplier/FormCreate.vue'),
    meta: createMeta(PERMISSION.SUPPLIER_CREATE, 'Create Supplier'),
  },
  {
    path: 'supplier/edit/:id',
    name: 'inventory-supplier-update',
    component: () => import('@/views/Inventories/supplier/FormUpdate.vue'),
    meta: createMeta(PERMISSION.SUPPLIER_UPDATE, 'Edit Supplier'),
  },
  {
    path: 'supplier/cash-payable/:id',
    name: 'inventory-supplier-cash-payable',
    component: () => import('@/views/Inventories/supplier/CashPayable.vue'),
    meta: createMeta(PERMISSION.SUPPLIER_READ, 'Supplier Cash Payable'),
  },
  {
    path: 'purchase-request',
    name: 'inventory-purchase-list',
    component: () => import('@/views/Inventories/purchaseRequest/index.vue'),
    meta: createMeta(PERMISSION.PURCHASE_REQUESTED_READ, 'Purchase Request List'),
  },
  {
    path: 'purchase-request/new',
    name: 'inventory-purchase-new',
    component: () => import('@/views/Inventories/purchaseRequest/FormCreate.vue'),
    meta: createMeta(PERMISSION.PURCHASE_REQUESTED_CREATE, 'Create Purchase Request'),
  },
  {
    path: 'purchase-request/edit/:id',
    name: 'inventory-purchase-edit',
    component: () => import('@/views/Inventories/purchaseRequest/FormUpdate.vue'),
    meta: createMeta(PERMISSION.PURCHASE_REQUESTED_UPDATE, 'Edit Purchase Request'),
  },
  {
    path: 'stock-in',
    name: 'inventory-stock-in-list',
    component: () => import('@/views/Inventories/stockIn/index.vue'),
    meta: createMeta(PERMISSION.STOCK_IN_READ, 'Stock In List'),
  },
  {
    path: 'stock-in/new',
    name: 'inventory-stock-in-new',
    component: () => import('@/views/Inventories/stockIn/FormCreate.vue'),
    meta: createMeta(PERMISSION.STOCK_IN_CREATE, 'Create Stock In'),
  },
  {
    path: 'stock-in/edit/:id',
    name: 'inventory-stock-in-edit',
    component: () => import('@/views/Inventories/stockIn/FormUpdate.vue'),
    meta: createMeta(PERMISSION.STOCK_IN_UPDATE, 'Edit Stock In'),
  },
  {
    path: 'stock-flow',
    component: () => import('@/views/Inventories/stockFlow/index.vue'),
    meta: createMeta([PERMISSION.STOCK_OUT_READ, PERMISSION.SUPPLIER_RETURN_READ], 'Stock Flow'),
    children: [
      {
        path: 'supplier-return',
        name: 'inventory-stock-flow-supplier-return-list',
        component: () => import('@/views/Inventories/stockFlow/supplierReturn/index.vue'),
        meta: createMeta(PERMISSION.SUPPLIER_RETURN_READ, 'Supplier Return'),
      },
      {
        path: 'supplier-return/new',
        name: 'inventory-stock-flow-supplier-return-new',
        component: () => import('@/views/Inventories/stockFlow/supplierReturn/FormCreate.vue'),
        meta: createMeta(PERMISSION.SUPPLIER_RETURN_CREATE, 'Create Supplier Return'),
      },
      {
        path: 'supplier-return/edit/:id',
        name: 'inventory-stock-flow-supplier-return-edit',
        component: () => import('@/views/Inventories/stockFlow/supplierReturn/FormUpdate.vue'),
        meta: createMeta(PERMISSION.SUPPLIER_RETURN_UPDATE, 'Edit Supplier Return'),
      },
      {
        path: 'stock-out',
        name: 'inventory-stock-flow-stock-out',
        component: () => import('@/views/Inventories/stockFlow/stockOut/index.vue'),
        meta: createMeta(PERMISSION.STOCK_OUT_READ, 'Stock Out'),
      },
    ],
  },
];
export const inventoriesRoute = [
  {
    path: 'inventory',
    component: () => import('@/components/partials/MenuLinkView.vue'),
    meta: createMeta(
      [
        PERMISSION.STOCK_IN_READ,
        PERMISSION.STOCK_OUT_READ,
        PERMISSION.SUPPLIER_RETURN_READ,
        PERMISSION.PART_ITEMS_READ,
        PERMISSION.PART_ISSUE_READ,
        PERMISSION.PART_RETURN_READ,
        PERMISSION.PURCHASE_REQUESTED_READ,
        PERMISSION.CATEGORY_READ,
        PERMISSION.STORAGE_READ,
        PERMISSION.SUBCATEGORY_READ,
      ],
      'Inventory List'
    ),
    children: [...inventoriesChildrenRoute],
  },
];
